import type { OutdatedEvaluation } from '../lib/api.ts'
import { Button } from './Button.tsx'

/**
 * Says that a verification was analysed before we changed how we judge (#605).
 *
 * What it shows may not be what the same prescription and quotation would get
 * today, and a pharmacist deciding on it should know before deciding. The way
 * out is the reverify the screen already has, offered here so the warning and
 * the remedy are one glance apart.
 *
 * Never updated by itself: a reverify reads the prescription again and costs
 * model calls, so it is the pharmacist's to ask for, one verification at a time.
 */
export interface OutdatedEvaluationNoticeProps {
  readonly outdated: OutdatedEvaluation
  readonly busy: boolean
  readonly onReverify: () => void
}

export function OutdatedEvaluationNotice({
  outdated,
  busy,
  onReverify,
}: OutdatedEvaluationNoticeProps) {
  return (
    <div
      role="status"
      className="rounded-base text-tP text-text-strong border-stroke-warning-weak bg-fill-warning-weak flex flex-wrap items-start justify-between gap-3 border p-3"
    >
      <div className="flex min-w-0 flex-col gap-1">
        <span className="text-tTiny text-text-weak font-semibold uppercase">Desatualizada</span>
        <span>
          Esta conferência foi analisada antes de uma mudança na forma como conferimos. O resultado
          pode ser diferente hoje.
        </span>
        <ul className="text-tSmall text-text-weak list-disc pl-5">
          {outdated.changes.map((change) => (
            <li key={change}>{change}</li>
          ))}
        </ul>
        <span className="text-tSmall text-text-weak">
          Ao atualizar, os apontamentos que não mudarem mantêm a decisão já tomada.
        </span>
      </div>
      <Button variant="primary" tone="brand" size="small" disabled={busy} onClick={onReverify}>
        {busy ? 'Atualizando…' : 'Atualizar comparação'}
      </Button>
    </div>
  )
}
